<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="50rem"
    scrollable
  >
    <template v-slot:activator="{ on: dialog }">
      <v-btn v-if="helper === true" v-on="{ ...dialog }" block>
        <v-icon small left>fa-file-csv</v-icon>
        Envoyer rapport
      </v-btn>
      <v-btn v-else v-on="{ ...dialog }" :block="$vuetify.breakpoint.xsOnly">
        <v-icon small left>fa-file-csv</v-icon>
        Envoyer rapport
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters>
          <v-btn small icon text @click="dialog = false">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-file-input
            filled
            class="no-before"
            prepend-icon=""
            prepend-inner-icon="fa-file-csv"
            v-model="file"
            accept=".csv"
            label="Sélectionner le fichier"
          ></v-file-input>
        </v-row>
        <v-row no-gutters v-show="loading">
          <v-progress-linear indeterminate></v-progress-linear>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="space-between" no-gutters>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :small="!$vuetify.breakpoint.xsOnly"
            :outlined="$vuetify.breakpoint.xsOnly"
            :text="!$vuetify.breakpoint.xsOnly"
            @click="dialog = false"
            :disabled="loading"
          >
            Annuler
          </v-btn>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :small="!$vuetify.breakpoint.xsOnly"
            :class="{ 'mt-3': $vuetify.breakpoint.xsOnly }"
            color="success"
            :disabled="loading || file === undefined"
            @click="sendReport"
          >
            Envoyer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
export default {
  name: "ReportSender",
  props: {
    helper: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      file: undefined
    };
  },
  methods: {
    async sendReport() {
      if (this.file) {
        try {
          this.loading = true;
          let formData = new FormData();
          formData.append("file", this.file);
          await api.sendReport(formData);
          const reportLoading = setInterval(() => {
            this.$store.dispatch("loadIntegratedTransactions", {
              uncompleted: true,
              deleted: false
            });
            this.$store.dispatch("loadIntegratedTransactionReports");
          }, 1000);
          setTimeout(() => clearInterval(reportLoading), 100000);
          this.dialog = false;
          this.file = undefined;
        } finally {
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style></style>
